const tableContentsButton = () => {
    const elem = document.querySelector(".js-table-contents");
    const bodyElem = document.querySelector("body");

    if (!elem) return;

    // bodyElem.classList.add("has-table-contents");
    // if (elem.classList.contains("is-commercial")) {
    //     bodyElem.classList.add("is-commercial");
    // }

    const button = elem.querySelector(".table-contents-button");
    const megaMenu = elem.querySelector(".mega-menu");
    const mmClose = megaMenu?.querySelector(".close-button");
    const mmMobile = document.querySelector(".js-table-contents-mobile");
    const mmMobileClose = mmMobile?.querySelector(".close-button");

    button?.addEventListener("click", () => {
        megaMenu?.classList.toggle("is-open");
        button?.classList.toggle("is-open");
        mmMobile?.classList.toggle("is-close");
    });

    mmClose?.addEventListener("click", () => button?.click());
    mmMobileClose?.addEventListener("click", () => button?.click());
};

const tableContentsBar = () => {
    const elem = document.querySelector(".js-table-contents");
    if (!elem) return;

    const scrollSection = document.querySelectorAll(".js-scroll-section");
    if (!scrollSection.length) {
        return;
    }

    const barContainer = elem.querySelector(".table-contents-bar");

    scrollSection.forEach((section, i) => {
        const barElem = document.createElement("div");
        barElem.classList.add("bar");

        const barFill = document.createElement("div");
        barFill.classList.add("bar-fill");

        barElem.appendChild(barFill);
        barContainer.appendChild(barElem);
    });

    barScroll(scrollSection, elem);
};

const barScroll = (sections, elem) => {
    const bars = elem.querySelector(".table-contents-bar")?.querySelectorAll(".bar-fill");
	const logoBlock = elem.querySelector(".table-contents-logo");
	const linkBlock = elem.querySelector(".table-contents-visit");

    window.addEventListener("scroll", () => {
        let scrolled = window.scrollY;
		let isInSection = false;

        sections.forEach((section, i) => {
            const sectionTop = section.offsetTop;
            const sectionHeight = section.offsetHeight;
		     
            if (scrolled >= sectionTop && scrolled < sectionTop + sectionHeight) {
                let perWidth = ((scrolled - sectionTop) / sectionHeight) * 100;
                bars[i].style.width = perWidth + "%";
				isInSection = true;
				
				let sectionLogo = section?.querySelector('.commercial-blocks')?.dataset.scrollImage;
				let sectionLink = section?.querySelector('.commercial-blocks')?.dataset.scrollUrl;
				
				if (!sectionLogo) {
					sectionLogo = section.dataset.scrollImage;
					sectionLink = section.dataset.scrollUrl;
				}

                if (logoBlock.querySelector('img') && linkBlock.querySelector('a')) {
                    const imageSrc = logoBlock.querySelector('img').src;
                    const butttonLink = linkBlock.querySelector('a');
                    if (imageSrc !== sectionLogo) {
                        logoBlock.querySelector('img').src = sectionLogo;
                        butttonLink.setAttribute("href", sectionLink);
                    }

                    if (!sectionLink) {
                        butttonLink.parentNode.removeChild(butttonLink);
                    }
                }

            } else if (scrolled >= sectionTop + sectionHeight) {
                bars[i].style.width = "100%";
            } else {
                bars[i].style.width = "0%";
            }

        });

        if (scrolled >= sections[0].offsetTop && scrolled < sections[sections.length - 1].offsetTop + sections[sections.length - 1].offsetHeight) {
            elem.classList.add("is-active");
        } else {
            elem.classList.remove("is-active");
        }
    }, { passive: true });
};

const tableContentsInit = () => {
    tableContentsButton();
    tableContentsBar();
};

document.addEventListener("DOMContentLoaded", function () {
    tableContentsInit();
});